<template>
    <div class="v-installer-lookup" :class="{'v-installer-lookup--open': showSuggestions}">


        <div class="v-installer-lookup__select" @click="open()">
            <template v-if="selected">
                {{ company.companyName }}
            </template>
            <template v-else>
                Velg intallatør

            </template>
            <div class="v-installer-lookup__caret">
                <i-caret/>
            </div>
        </div>


        <div class="v-installer-lookup__selector-pane" v-if="showSuggestions" v-click-outside="close">

            <div class="v-installer-lookup__search">
                <v-input :disabled="disabled" label="Søk" v-model="search" @keyup="typing()"></v-input>
            </div>

            <div class="v-installer-lookup__loader" :class="{'v-installer-lookup__loader--active': request.loading}">
                <v-ellipsis-loader color="green"/>
            </div>
            <div class="v-installer-lookup__suggestions">
                <template v-for="suggestion in suggestions.data">
                    <div class="v-installer-lookup__suggestion" @click="setCompany(suggestion)">
                        <v-installer-lookup-entry :company="suggestion"/>
                    </div>
                </template>
            </div>

            <div class="v-installer-lookup__not-found"
                 v-if="search.length > 1 && !request.loading && suggestions.totalPages == 0">
                Finner ikke firma "<span class="v-installer-lookup__typed">{{ search }}</span>"
            </div>

            <div class="v-installer-lookup__pagination" v-if="suggestions.totalPages > 0">

                <div class="v-installer-lookup__prev"
                     :class="{'v-installer-lookup__prev--active': suggestions.page > 1}"
                     @click="currentPage--">
                    <i-caret direction="left"/>
                </div>

                <div class="v-installer-lookup__current-page">
                    Side <b>{{ suggestions.page }}</b> av {{ suggestions.totalPages }}
                </div>

                <div class="v-installer-lookup__next"
                     :class="{'v-installer-lookup__next--active': suggestions.totalPages > suggestions.page}"
                     @click="currentPage++">
                    <i-caret direction="right"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import _ from "lodash"
  import vInstallerLookupEntry from "./vInstallerLookupEntry"
  import vEllipsisLoader from "./vEllipsisLoader"
  import vInput from "./vInput"
  import api from "../utils/api"
  import iCaret from "../components/icons/caret"

  export default {
    name: "vInstallerLookup",
    components: {
      vEllipsisLoader,
      vInstallerLookupEntry,
      vInput,
      iCaret,
    },
    props: {
      lookupUrl: { type: String, default: process.env.VUE_APP_API_URL  + "/installers" },
      disabled: { type: Boolean, default: false },
      zip: { type: String, default: "" },
      value: {
        type: Object, default: function () {
          return {}
        }
      }
    },
    data() {
      return {
        search: "",
        showSuggestions: false,
        selected: false,
        currentPage: 1,
        request: {
          loading: false,
          response: {
            data: []
          }
        },

        company: this.value,
        rawData: [],
      }
    },
    watch: {

      company: {
        handler: function () {
          this.$emit("input", this.company);
        },
        deep: true,
      }

    },
    methods: {
      setCompany(data) {
        this.company = data;
        this.showSuggestions = false;
        this.selected = true;
        this.resetSuggestions();
      },
      resetSuggestions() {
        this.request.response.data = [];
      },

      open() {
        this.showSuggestions = true;
        this.lookupCompany();
      },
      close() {
        this.showSuggestions = false;
      },

      typing() {
        this.lookupCompany();
      },
      lookupCompany: _.debounce(function () {
        console.log("looking up company");
        this.request.loading = true;

        var that = this;
        api().get(that.lookupUrl, {
          params: {
            zip: that.zip.length ? that.zip : null,
            search: that.search.length ? that.search : null
          }
        }).then(function (response) {
          that.currentPage = 1;
          // cloning response to not link a direct copy to cached data
          that.request.response = _.clone(response.data);
        }).catch(function (error) {
        }).finally(function () {
          that.request.loading = false;
        });
      }, 300),

    },
    mounted() {
      if (!_.isEmpty(this.company)) {
        this.selected = true;
      }
    },


    computed: {
      suggestions() {
        let items = this.request.response.data;
        var page = this.currentPage,
          perPage = 5,
          offset = (page - 1) * perPage,
          paginatedItems = _.drop(items, offset).slice(0, perPage);

        return {
          page: page,
          perPage: perPage,
          total: items.length,
          totalPages: Math.ceil(items.length / perPage),
          data: paginatedItems
        };
      }
    }
  }
</script>

<style lang="scss">

    //noinspection CssUnknownTarget
    @import '~@/scss/main.scss';

    .v-installer-lookup {

        position: relative;

        &__select {
            font-size: .85em;
            width: 100%;
            background-color: #f7f7f7;
            border: 0;
            cursor: pointer;
            border-radius: 5em;
            padding: .5em 1em;
            outline: none;
            position: relative;
        }


        &__caret {
            position: absolute;
            width: .75em;
            right: 1em;
            top: 50%;
            fill: #777;
            transform: translateY(-50%);
        }

        &__search {
            font-size: .85em;
            position: relative;
            z-index: 10;
            padding: .5em 1.5em;

        }

        &__selector-pane {

            top: 100%;
            background-color: white;
            width: 101%;
            margin-left: -.5%;
            z-index: 10;
            position: absolute;
            box-shadow: 0 0 1em 0 rgba(0, 0, 0, 0.1);
            border-top: none;
        }

        &__loader {
            text-align: center;
            opacity: 0;
            height: 0;
            transition: 0.2s ease all;
            transform: scale(.8);
            &--active {
                height: 1.5em;
                opacity: 1;
                transform: scale(1);
            }
        }


        &__suggestions {
            padding-bottom: 1em;
        }

        &__suggestion {
            padding: .5em 1.5em;
            cursor: pointer;
            &:hover {
                color: $primary-color;
            }
        }

        &__not-found {
            padding: .75em;
        }

        &__pagination {
            display: flex;
            padding: 0.2em .75em;
            justify-content: center;
            align-items: center;
            color: $dim-color;
            border-top: 1px solid #DDD;
        }

        &__prev,
        &__next {
            pointer-events: none;
            width: 2.5em;
            height: 2.5em;
            fill: #f0f0f0;
            padding: .3em 1em;
            cursor: pointer;

            &--active {
                fill: black;
                pointer-events: auto;
            }
        }

        &__current-page {
            padding: 0.2em;
            font-size: .8em;
            text-align: center;
        }

        &__use {
            border-top: 1px solid #DDD;
            cursor: pointer;
            padding: .75em;
        }

        &__typed {
            font-weight: 600;

        }

        &__input {
            width: 100%;
            padding: .25em 0;

            &--postcode {
                margin-right: 1em;
                width: auto;
                min-width: 3em;
            }
        }

        &--open {

            .v-installer-lookup {

                &__details {
                    opacity: .6;

                }
            }

        }

        &__location {
            display: flex;
        }

    }

</style>
